(function ($, Drupal) {
  'use strict';

  // Extra comparison function for Drupal state system.
  Drupal.states.Dependent.comparisons['Object'] = function (reference, value) {
    if ('regex' in reference) {
      return (new RegExp(reference.regex, reference.flags)).test(value);
    }
    else {
      return reference.indexOf(value) !== false;
    }
  };
})(jQuery, Drupal);
